import { v4 as uuid } from 'uuid'
import { isBoolean } from 'lodash'
import { getChangedValues } from 'utils/formik'

/**
 * Returns only fields which have been changed
 *
 * @param {array} values all values from formik - both changed and not changed
 * @param {array} initialValues formik's initial values
 * @param {string} venueUuid current venue uuid
 *
 * @return {array} venueSettingsToSend only changed fields with corrensponding settings
 */

export const renderFieldsToCreateSettings = (
  values,
  initialValues,
  venueUuid
) => {
  // get only values which were changed and remove all unchanged values
  const filteredValues = getChangedValues(values, initialValues)

  const venueSettingsToSend = Object.entries(filteredValues).reduce(
    (result, [key, value]) => {
      let convertedNumberValue

      // check if current iterated element is number field
      // we have to replace empty string with null
      if (
        [
          // uncomment when it this settings will be implemented
          // 'max_order_amount_in_dollars',
          'alcohol_limit_per_customer',
        ].includes(key)
      ) {
        // if value is empty string return null
        // if value is not empty convert this value to Number
        convertedNumberValue =
          value === '' || value === 0 ? null : Number(value)

        // if it is not number field, leace as it is
      } else {
        convertedNumberValue = value
      }

      // stringify booleans: true -> 'true', false -> 'false'
      const stringifiedValue = isBoolean(convertedNumberValue)
        ? convertedNumberValue.toString()
        : convertedNumberValue

      // add new value
      const settingObjectWithChangedValueWithAddedValue = {
        name: key,
        value: stringifiedValue,
        standId: null,
        externalRefId: uuid(),
        venueUuid,
      }

      return [...result, settingObjectWithChangedValueWithAddedValue]
    },
    []
  )

  return venueSettingsToSend
}
